import { Link, isRouteErrorResponse, useRouteError } from 'react-router';
import { BasicPageLayout } from '@/layouts/page/basic-page-layout';
import { Button } from '@/components/ui/button';
import { PATHS } from '@/routes/paths';

function describeRouteError(error: unknown): { title: string; message: string } {
  if (isRouteErrorResponse(error)) {
    return {
      title: `${error.status} ${error.statusText}`,
      message: typeof error.data === 'string' ? error.data : 'This page could not be loaded.',
    };
  }
  if (error instanceof Error) {
    return { title: 'Something went wrong', message: error.message };
  }
  return { title: 'Something went wrong', message: 'An unexpected error occurred.' };
}

export function RouteError(): React.ReactElement {
  const { title, message } = describeRouteError(useRouteError());
  return (
    <BasicPageLayout
      title={title}
      description={message}
      footer={
        <Button asChild variant="outline">
          <Link to={PATHS.root}>Go back</Link>
        </Button>
      }
    />
  );
}
